export const APP_HOME = { label: 'Home', url: '/' };
export const FEATURE_HOME = {
  label: 'Payment Orchestration',
  url: '/payment-orchestration',
};
export const PaymentOrchestrationLanding = [APP_HOME, FEATURE_HOME];

// Page: Rules
export const RULE_LIST_ROUTE = '/payment-orchestration/rules';
export const ruleListBreadcrumb = [
  ...PaymentOrchestrationLanding,
  { label: 'Rules', url: RULE_LIST_ROUTE },
];

// Page: Add Rule Form
export const RULE_ADD_ROUTE = '/payment-orchestration/rules/add';
export const addRuleBreadcrumb = [
  ...ruleListBreadcrumb,
  { label: 'Add', url: RULE_LIST_ROUTE },
];

export const updateRuleBreadcrumb = (id) => [
  ...ruleListBreadcrumb,
  { label: 'Update', url: `${RULE_LIST_ROUTE}/${id}` },
];

// Page: Rules Sources
export const RULE_SOURCE_LIST_ROUTE = '/payment-orchestration/rules-sources';
export const RULE_SOURCE_ADD_ROUTE = '/payment-orchestration/rules-sources/add';

export const viewRuleSources = [
  ...PaymentOrchestrationLanding,
  { label: 'Sources', url: RULE_SOURCE_LIST_ROUTE },
];

// Page: Dynamic Rules - List
export const DYNAMIC_RULE_LIST_ROUTE = '/payment-orchestration/dynamic-rules';
export const dynamicRuleListBreadcrumb = [
  ...PaymentOrchestrationLanding,
  { label: 'Dynamic Rules', url: DYNAMIC_RULE_LIST_ROUTE },
];

// Page: Dynamic Rules - Add
export const DYNAMIC_RULE_ADD_ROUTE =
  '/payment-orchestration/dynamic-rules/add';
export const dynamicRuleAddBreadcrumb = [
  ...dynamicRuleListBreadcrumb,
  { label: 'Add', url: DYNAMIC_RULE_ADD_ROUTE },
];

export const updateDynamicRuleBreadcrumb = (id) => [
  ...dynamicRuleListBreadcrumb,
  { label: 'Update', url: `${DYNAMIC_RULE_LIST_ROUTE}/${id}` },
];
